var map = {
	"./ICON_menu_alarmTypes.svg": 9838,
	"./ICON_menu_closed.svg": 390,
	"./ICON_menu_companies.svg": 8266,
	"./ICON_menu_contract-terms.svg": 1814,
	"./ICON_menu_dpa-contracts.svg": 9145,
	"./ICON_menu_guides.svg": 1397,
	"./ICON_menu_licenses.svg": 5243,
	"./ICON_menu_open.svg": 8031,
	"./ICON_menu_residents.svg": 802,
	"./ICON_menu_users.svg": 4428,
	"./ICON_menu_view-terms-and-conditions.svg": 514
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1933;